import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { Button } from '@repo/ui/button';
import { Input } from '@repo/ui/input';
import { Search, X } from 'lucide-react';
import { Activity } from 'react';
import z from 'zod';
import type { TTableFilters } from '@/types/table';

export const ZOwnerTableFiltersSchema = z.object({
  search: z.string(),
});
export type TOwnersTableFilters = z.infer<typeof ZOwnerTableFiltersSchema>;

export interface OwnersTableFiltersProps extends TTableFilters<TOwnersTableFilters> {}

export function OwnersTableFilters({
  filters,
  onFilterChange,
  onClearFilters,
  hasFilters,
}: OwnersTableFiltersProps) {
  useLocale();

  return (
    <div className="space-y-4">
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Search className="absolute start-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            className="ps-9"
            onChange={(e) => onFilterChange('search', e.target.value)}
            placeholder={t('workspace.searchOwnersByNameEmailOrOrganization')}
            value={filters.search}
          />
        </div>
        <Activity mode={hasFilters ? 'visible' : 'hidden'}>
          <Button onClick={onClearFilters} variant="outline">
            <X className="h-4 w-4" />
            {t('workspace.clearFilters')}{' '}
          </Button>
        </Activity>
      </div>
    </div>
  );
}
